
import Vue from 'vue';
import KennelList from "../../views/Admin/Searches/KennelList.vue";
import AdminCoownersList, { OwnershipType } from "./AdminCoownersList.vue";

import kennelService from "@/services/admin/kennelService";

export default Vue.extend({
  name: 'AdminKennelSearchDialog',
  props: {
    kennelId: { type: String },
    initialKennelId: { type: String },
    isEditMode: { type: Boolean },
    hideSearch: { type: Boolean },
    showOwners: { type: Boolean },
    returnOwners: { type: Boolean },
    label: { type: String },
  },
  components: {
    AdminCoownersList,
    KennelList
  },
  data: function() {
      return {
        showKennelSearchDialog: false,
        kennelInfo: {} as any,
        selectedKennelId: this.$props.kennelId
      };
  },
  computed: {
    kennelOwnershipType: function() {
      return OwnershipType.Kennel;
    },
  },
  methods: { 
    onKennelSelected: function(kennel: any){
        this.showKennelSearchDialog = false;
        this.selectedKennelId = kennel?.kennelId?.trim();
        this.loadKennelInfo();
    },
    loadKennelInfo: function() {
        if(!this.selectedKennelId){
          this.kennelInfo = {};
          return;
        }
        
        this.$store.dispatch("changeLoaderStatus",true);
        kennelService.getKennelById(this.selectedKennelId).then((res: any) => {
          if(res){
            this.kennelInfo = res;
            if (this.returnOwners) this.$emit('update-owners', [...this.kennelInfo.owners] ?? []);
          } else {
            this.kennelInfo = {};
          }
        }).catch(e => {
          console.log(e); 
          this.kennelInfo = {};
        })
        .finally(() => {
          this.$store.dispatch("changeLoaderStatus",false);
        });
    },
  },
  watch: {    
    kennelId: function(newVal, oldVal){
      if(newVal != oldVal)
        this.selectedKennelId = newVal;    
    },    
    initialKennelId: function(newVal, oldVal){
      if(newVal != oldVal) {
        this.loadKennelInfo(); 
      }   
    },
    selectedKennelId: function(newVal, oldVal){      
      this.$emit('update:kennelId', newVal);
    }
  }
});
